import { useState } from "react";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("Mật khẩu xác nhận không khớp");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        old_password: form.old_password,
        new_password: form.new_password,
      });
      toast.success("Đổi mật khẩu thành công");
      setForm({ old_password: "", new_password: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#0a0a0a] border border-zinc-800 text-white rounded-sm px-4 py-2.5 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors placeholder:text-zinc-600";
  const labelCls = "block text-xs font-semibold uppercase tracking-[0.1em] text-zinc-400 mb-2";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-[#0a0a0a] border-zinc-800">
        <DialogHeader>
          <DialogTitle className="font-display text-white">Đổi mật khẩu</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className={labelCls}>Mật khẩu hiện tại</label>
            <input data-testid="cp-old" type="password" value={form.old_password} onChange={(e) => setForm({ ...form, old_password: e.target.value })} className={inputCls} required />
          </div>
          <div>
            <label className={labelCls}>Mật khẩu mới</label>
            <input data-testid="cp-new" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inputCls} required />
          </div>
          <div>
            <label className={labelCls}>Xác nhận mật khẩu mới</label>
            <input data-testid="cp-confirm" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={inputCls} required />
          </div>
          <button data-testid="cp-submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-[#ff1a1a] text-white font-bold rounded-sm px-6 py-2.5 transition-colors disabled:opacity-50">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Cập nhật
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
